import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 10px;
`;

export const ListWrapper = styled.div`
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  padding-top: 15px;
  /* padding: 15px; */
`;

export const ItemWrapper = styled.div`
  width: 100%;
  background-color: white;
  padding: 10px 15px 10px 10px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  gap: 15px;
  border: 1px solid black;
  .data {
    height: fit-content;
    .name {
    }
  }
  .rightside {
    height: fit-content;
    margin-left: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
  }
`;

const imgWidth = 70;
export const CarImgWrapper = styled.div`
  width: ${imgWidth}px;
  height: ${imgWidth * 0.8}px;
  img {
    border-radius: 10px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    /* border: 1px solid black; */
  }
`;

export const ListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
